import React from 'react';

export default function Button({ variant = 'primary', className = '', children, type = 'button', ...rest }){
  const base = variant === 'ghost' ? 'btn-ghost' : variant === 'icon' ? 'icon-btn' : 'btn';
  const cls = `${base}${className ? ' ' + className : ''}`;
  return (
    <button type={type} className={cls} {...rest}>
      {children}
    </button>
  );
}
